// Components that are common enough to include globally
import ApiErrors from './ApiErrors'
import CheckChip from './CheckChip'
import TimePicker from './TimePicker'
import DatePicker from './DatePicker'
import NumberField from './NumberField'
import PageBar from './PageBar'
import vBoolean from './vBoolean' // TODO:  Replace. Vuetify 2.x should have eliminated the need for this
import DaysSwitch from './DaysSwitch'
import FormattedInput from './FormattedInput'
import MemberPreferences from './MemberPreferences'
import MemberSelect from './MemberSelect'

export default [
  ApiErrors,
  CheckChip,
  TimePicker,
  DatePicker,
  NumberField,
  PageBar,
  vBoolean,
  DaysSwitch,
  FormattedInput,
  MemberPreferences,
  MemberSelect
]
